import { Component, type ReactNode } from 'react';

/**
 * A rendering error in one page is shown as an error, not as a blank screen,
 * and the rest of the shell (navigation, theme) keeps working.
 */
export class ErrorBoundary extends Component<{ children: ReactNode; resetKey?: string }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidUpdate(prev: { resetKey?: string }) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null });
  }

  render() {
    if (this.state.error) {
      return (
        <div className="state state-error" role="alert">
          <h2>Diese Ansicht konnte nicht angezeigt werden.</h2>
          <p>{this.state.error.message}</p>
          <p className="muted small">Die Daten sind nicht verloren; das ist ein Darstellungsfehler.</p>
          <button type="button" className="button" onClick={() => this.setState({ error: null })}>
            Erneut versuchen
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
